import { render, staticRenderFns } from "./ItemsPanel.vue?vue&type=template&id=efb0f08e&scoped=true"
import script from "./ItemsPanel.vue?vue&type=script&lang=js"
export * from "./ItemsPanel.vue?vue&type=script&lang=js"
import style0 from "./ItemsPanel.vue?vue&type=style&index=0&id=efb0f08e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "efb0f08e",
  null
  
)

export default component.exports